import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const DragAndDropComponent = ({ items, onDragEnd, onRemove }) => {
	return (
		<DragDropContext onDragEnd={onDragEnd}>
			<Droppable droppableId='droppable'>
				{(provided) => (
					<div
						ref={provided.innerRef}
						{...provided.droppableProps}
					>
						{items.map((item, index) => (
							<Draggable
								key={item.key}
								draggableId={item.key}
								index={index}
							>
								{(provided) => (
									<div
										ref={provided.innerRef}
										{...provided.draggableProps}
										{...provided.dragHandleProps}
										className='admin_drag_item'
										style={provided.draggableProps.style}
									>
										<item.Component {...item.props} />
										<button className='admin_remove_btn' onClick={() => onRemove(index)}>×</button>
									</div>
								)}
							</Draggable>
						))}
						{provided.placeholder}
					</div>
				)}
			</Droppable>
		</DragDropContext>
	);
};

export default DragAndDropComponent;
